 <div class=" light-bg">
   <div class="col-lg-12" style="padding-bottom: 5px;">
     <div class="">
       <div class="pt-0 pb-0" style="padding:0;">
         <div class="login-block" >
           <div class="m-portlet__body">
             <div>
               <div class="field-wrapper">
                 <div class="text-right">{{'DEACTIVATION_DATE' | dictionary}}: </div>
                 <DateChooser #Date NullDateLabel="(None)" width="120px">
                 </DateChooser>
               </div>

             </div>

             <div>
               <div class="form-group" style="text-align: center; margin-top: 10px">
                 <button
                         class="button-1" (click)="save()">
                   {{'SAVE' | dictionary}}
                 </button>
                 <button (mousedown)="cancel()"
                         class="ml-15  button-1">
                   {{'CANCEL' | dictionary}}
                 </button>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>

   <app-pop-up-dialog minHeight="40px" minWidth="300px" [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
   </app-pop-up-dialog>

 </div>
